import { TableColumnsSetting } from '@/interfaces/table-setting';
import { OrderSliModel } from '@/models/imports/order-sli-model';

export class OrderSliSettingsTable {
  public static getColumnsSetting(): TableColumnsSetting<string> {
    return [
      {
        name: 'id',
        text: 'Id',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'importId',
        text: 'Import Id',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'idDocument',
        text: 'ID Documento',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'ordine',
        text: 'Ordine',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'dataOrder',
        text: 'Data Ordine',
        type: 'date',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'confermata',
        text: 'Confermata',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'dataContratto',
        text: 'Data Contratto',
        type: 'date',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'denominazioneCommerciale',
        text: 'Denominazione Commerciale',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'tmaimg',
        text: 'TMA IMG',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'colEst',
        text: 'Colore Esterno',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'colInt',
        text: 'Colore Interno',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'estensioni',
        text: 'Estensioni',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'optionalsImportatore',
        text: 'Optional Importatore',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'stat',
        text: 'Stato',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'tipo',
        text: 'Tipo',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'sf',
        text: 'SF',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'my',
        text: 'MY',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'venditore',
        text: 'Venditore',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'codiceDiAgente',
        text: 'Codice Agente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'insStatusFatto',
        text: 'INS Status Fatto',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'createdAt',
        type: 'datetime',
        text: 'Creato il',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'updatedAt',
        type: 'datetime',
        text: 'Modificato il',
        filter: {
          type: 'dateRange',
        },
      },
    ];
  }
}
